export const COPIES_PREFIX = 'inspire_project_perseus.delivery_page';
